export default __webpack_public_path__ + "static/media/qs-grey.2413eac8.svg";